<template>
  <div>
    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام شرکت:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.name.$model"
            :state="validateState('name')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن نام شرکت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام شرکت به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            ref="en_company_name"
            v-model="$v.value.en_company_name.$model"
            :state="validateState('en_company_name')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام شرکت به انگلیسی را به صورت صحیح وارد
            کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="شناسه ملی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.com_shenase.$model"
            :state="validateState('com_shenase')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن شناسه ملی شرکت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="شماره ثبت:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.register_number.$model"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="تاریخ ثبت:"
          label-for="example-input-1"
        >
        <date-picker
            required
            v-model="$v.value.register_date.$model"
            ref="register_date"
          ></date-picker>
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام مدیر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.fa_name.$model"
            ref="fa_name"
            :state="validateState('fa_name')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام خانوادگی مدیر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.fa_family.$model"
            :state="validateState('fa_family')"
            ref="fa_family"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام خانوادگی را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام پدر مدیر"
          label-for="example-input-1"
        >
          <b-form-input
            :disabled="disabled"
            id="example-input-1"
            ref="fa_father"
            :state="validateState('fa_father')"
            v-model="$v.value.fa_father.$model"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام پدر را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام مدیر به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            :disabled="disabled"
            ref="en_name"
            v-model="$v.value.en_name.$model"
            :state="validateState('en_name')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام انگلیسی را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام مدیر به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            :disabled="disabled"
            ref="en_name"
            v-model="$v.value.en_name.$model"
            :state="validateState('en_name')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام انگلیسی را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام پدر مدیر به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            :disabled="disabled"
            ref="en_father"
            :state="validateState('en_father')"
            v-model="$v.value.en_father.$model"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام پدر به انگلیسی را به صورت صحیح وارد
            کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="کد ملی مدیر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.national_card_number.$model"
            :disabled="disabled"
            :readonly="readonly"
            ref="national_card_number"
            :state="validateState('national_card_number')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن کد ملی اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="شماره شناسنامه مدیر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.id_number.$model"
            :disabled="disabled"
            :readonly="readonly"
            ref="national_card_number"
          ></b-form-input>

        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="تلفن همراه مدیر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.mobile.$model"
            ref="mobile"
            :state="validateState('mobile')"
            :readonly="readonly"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن تلفن همراه اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="پست الکترونیکی"
          label-for="example-input-1"
        >
          <b-form-input
            disabled
            id="example-input-1"
            ref="email"
            v-model="$v.value.email.$model"
            :state="validateState('email')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >پست الکترونیکی اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>
    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-row>
          <b-col>
            <b-form-group
              id="example-input-group-1"
              label="تلفن ثابت:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.value.phone.$model"
                :state="validateState('phone')"
                :disabled="disabled"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن تلفن ثابت اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group
              id="example-input-group-1"
              label="کد شهر:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.value.pre_phone.$model"
                :state="validateState('pre_phone')"
                :disabled="disabled"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن کد شهر اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="جنسیت:"
          label-for="example-input-1"
        >
          <MDDropdown
            :disabled="disabled"
            v-bind:group="18"
            ref="mdid18_gender"
            v-model="$v.value.mdid18_gender.$model"
          ></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن جنسیت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="تاریخ تولد:"
          label-for="example-input-1"
        >
          <date-picker
            required
            v-model="$v.value.birth_date.$model"
            ref="birth_date"
            :max="maxDate"
          ></date-picker>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن تاریخ تولد اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
const enchars = (value, vm) => !/[^A-Za-z0-9]/.test(value);
const numbers = (value, vm) => !/[^0-9]/.test(value);
const fachars = (value, vm) => /[^A-Za-z0-9]/.test(value);
const phone = (value, vm) => /^0\d{5}/g.test(value) && !/^09/g.test(value);
const mobile = (value, vm) => !/^09{9}/g.test(value);
const prephone = (value, vm) => /0\d{2}/.test(value);
export default {
  mixins: [validationMixin],
  name: "PersonInfo",
  props: ["value", "disabled", "validateInputswatcher", "readonly"],
  components: {
    MDDropdown,
  },
  data() {
    return { maxDate: "" };
  },
  validations: {
    value: {
      register_date: {
      },
      register_number: {
      },
      id_number: {
      },
      email: {
        required,
        email,
      },
      name: {
        fachars,
        required,
      },
      com_shenase: {
        required,
        numbers,
        minLength: minLength(8),
      },
      fa_name: {
        fachars,
        required,
        minLength: minLength(3),
      },
      fa_family: {
        fachars,
        required,
        minLength: minLength(3),
      },
      en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_family: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_company_name: {
        enchars,
      },
      national_card_number: {
        required,
      },
      mobile: {
        required,
        mobile,
      },
      merchant_type: {
        required,
      },
      pre_phone: {
        required,
        prephone,
      },
      fa_father: { fachars, required, minLength: minLength(3) },
      en_father: { enchars, required, minLength: minLength(3) },
      phone: { required, phone },
      mdid18_gender: { required },
      birth_date: { required },
    },
  },
  watch: {
    value: function(newval, oldval) {
      //this.form = newval;
    },
    validateInputswatcher: function(newval, oldval) {
      this.validateInputs();
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.value.$touch();
    },
  },
  created() {
    //this.form = this.value;

    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var c = new Date(year - 18, month, day);
    this.maxDate = persianDate.getDateByFormat(c);
  },
};
</script>
